


















import Vue from 'vue';
import Component from 'vue-class-component';
import firebase from '@/plugins/firebase';
import { Project } from '@/types';
import { getModule } from 'vuex-module-decorators';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import Admin from '@/store/modules/admin';
import store from '@/store/store';
import { Watch } from 'vue-property-decorator';

const db = firebase.firestore();
const adminModule = getModule(Admin, store);

@Component
export default class AdminIndex extends Vue {
  snackbar = false;
  valid = false;

  get project(): Project {
    return adminModule.project;
  }

  @Watch('$route')
  async setProject() {
    const projectId = this.$route.params.id;
    await adminModule.bindProject(projectId);
    if (!this.project.id) this.$router.push('/');
    adminModule.bindCollections(projectId);
  }

  async created() {
    this.setProject();
  }
}
